import DotPagination from "./component-library42.mjs";
import Arrow from "./component-library4.mjs";
import PlayPauseButton from "./component-library13.mjs";
import reducedMotionMixin from "./component-library105.mjs";
import { useCssVars } from "vue";
import "./component-library188.mjs";
import normalizeComponent from "./component-library82.mjs";
const __default__ = {
  name: "AnimatedGallery",
  components: {
    Arrow,
    DotPagination,
    PlayPauseButton
  },
  mixins: [reducedMotionMixin],
  props: {
    items: {
      type: Array,
      required: true
    },
    initialSelectedIndex: {
      type: Number,
      default: 0
    },
    animation: {
      type: String,
      default: "left-fade"
    },
    animationDuration: {
      type: Object,
      default: () => ({
        enter: "0.2s",
        leave: "0.2s"
      })
    },
    autoPlay: {
      type: Boolean,
      default: false
    },
    autoPlayDuration: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      selectedItemIndex: this.initialSelectedIndex,
      componentTexts: {
        selectItem: "Bild Anzeigen",
        controlGroup: "Navigation",
        prevControl: "Vorheriges",
        nextControl: "Nächstes"
      },
      autoPlayInterval: null,
      isPaused: false
    };
  },
  computed: {
    itemCount() {
      return this.items.length;
    },
    lastItemIndex() {
      return this.itemCount - 1;
    },
    hasMultipleItems() {
      return this.itemCount > 1;
    },
    selectedItem() {
      return this.items[this.selectedItemIndex];
    },
    animationDurationEnter() {
      return this.animationDuration.enter || "0.5s";
    },
    animationDurationLeave() {
      return this.animationDuration.leave || "0.5s";
    },
    pages() {
      const pagination = [];
      for (let i = 0; i < this.itemCount; i += 1) {
        pagination.push({ number: i, active: i === this.selectedItemIndex });
      }
      return pagination;
    }
  },
  watch: {
    initialSelectedIndex(newIndex) {
      this.selectItem(newIndex);
    },
    autoPlay: {
      handler(play) {
        if (!this.prefersReducedMotion)
          this.toggleAutoPlay(play);
      },
      immediate: true
    }
  },
  mounted() {
    if (this.autoPlay && this.prefersReducedMotion) {
      this.toggleAutoPlay(false);
    }
  },
  methods: {
    selectItem(index) {
      this.selectedItemIndex = Math.max(0, Math.min(index, this.lastItemIndex));
      this.resetAutoPlay();
    },
    incrementSelectedItemIndex() {
      if (this.selectedItemIndex === this.lastItemIndex) {
        this.selectItem(0);
        return;
      }
      this.selectItem(this.selectedItemIndex + 1);
    },
    decrementSelectedItemIndex() {
      if (this.selectedItemIndex === 0) {
        this.selectItem(this.lastItemIndex);
        return;
      }
      this.selectItem(this.selectedItemIndex - 1);
    },
    startAutoPlay() {
      this.autoPlayInterval = setTimeout(() => {
        this.incrementSelectedItemIndex();
      }, this.autoPlayDuration * 1e3);
    },
    stopAutoPlay() {
      if (!this.autoPlayInterval)
        return;
      clearTimeout(this.autoPlayInterval);
    },
    resetAutoPlay() {
      this.stopAutoPlay();
      if (!this.autoPlay || this.isPaused)
        return;
      this.startAutoPlay();
    },
    toggleAutoPlay(value = null) {
      this.isPaused = value !== null ? !value : !this.isPaused;
      if (this.isPaused) {
        this.stopAutoPlay();
      } else {
        this.startAutoPlay();
      }
    }
  }
};
const __injectCSSVars__ = () => {
  useCssVars((_vm, _setup) => ({
    "9c6d4436": _vm.animationDurationEnter,
    "9bb0b478": _vm.animationDurationLeave
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
const _sfc_main = __default__;
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("div", { staticClass: "animated-gallery" }, [_c("div", { staticClass: "animated-gallery__stage" }, [_c("Transition", { attrs: { "mode": "out-in", "name": _vm.animation } }, [_c("div", { key: _vm.selectedItemIndex }, [_vm._t("stageItem", null, { "selectedItem": _vm.selectedItem, "index": _vm.selectedItemIndex }), _vm.$slots.badge ? [_vm._t("badge", null, { "index": _vm.selectedItemIndex })] : _vm._e()], 2)])], 1), _vm.itemCount > 1 ? _c("div", { staticClass: "animated-gallery__controls", attrs: { "role": "group", "aria-label": _vm.componentTexts.controlGroup } }, [_c("Arrow", { staticClass: "animated-gallery__arrow", attrs: { "set-position": "", "direction": "left", "aria-label": "Vorheriges Bild" }, on: { "change": _vm.decrementSelectedItemIndex } }), _c("Arrow", { staticClass: "animated-gallery__arrow", attrs: { "set-position": "", "direction": "right", "aria-label": "Nächstes Bild" }, on: { "change": _vm.incrementSelectedItemIndex } })], 1) : _vm._e(), _vm.itemCount > 1 ? [_vm._t("pagination", function() {
    var _a;
    return [_c("DotPagination", { staticClass: "animated-gallery__pagination", attrs: { "pages": _vm.pages, "prefix": "Teaser" }, on: { "update": _vm.selectItem } }), ((_a = _vm.pages) == null ? void 0 : _a.length) > 1 ? _c("PlayPauseButton", { attrs: { "is-paused": _vm.isPaused, "aria-label": _vm.isPaused ? "Slider abspielen" : "Slider pausieren" }, on: { "click": _vm.toggleAutoPlay } }) : _vm._e()];
  })] : _vm._e()], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "a5c46709",
  null,
  null
);
const animatedGallery = __component__.exports;
export {
  animatedGallery as default
};
